import { VFC } from 'react';
import { Route, Navigate, useLocation, useMatch, Routes } from 'react-router';
import queryString from 'query-string';
import { useUser } from './hooks/useUser';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Login } from './pages/Login';
import { Accounts } from './pages/Accounts';
import { Flows } from './pages/Flows';

export const App: VFC = () => {
    const { user } = useUser();
    const location = useLocation();
    const loginMatch = useMatch('/login');

    if (loginMatch) {
        const from = queryString.parse(location.search, {
            arrayFormat: 'none',
        })?.from as string | null;

        return (<Login from={from} />);
    } else if (user == null) {
        return (<Navigate to={`/login?from=${encodeURIComponent(location.pathname)}`} />);
    }

    return (
        <Layout>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/accounts" element={<Accounts />} />
                <Route path="/flows/*" element={<Flows />} />
            </Routes>
        </Layout>
    );
};
